import React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import AllLogs from './all-logs';
import { FontIcon } from 'material-ui';
import LoadingOverlay from '../../../../tc-ui/loading-overlay';

const ChangeLogRouter = props => {
  const {
    changeLogs,
    loadingLogs,
    goBack,
  } = props;
  return (
    <div className="full-screen-page">
      <LoadingOverlay loading={loadingLogs} />
      <AllLogs logs={changeLogs}/>
      <div
        style={{ position: 'fixed', top: 6, right: 16, cursor: 'pointer', zIndex: 20 }}
        onClick={goBack}
      >
        <FontIcon className="tc-icon-close" style={{ fontSize: '36px', color: 'rgba(0, 0, 0, 0.54)' }} />
      </div>
    </div>
  );
};

const mapState = ({
  contracting,
}) => ({
  changeLogs: contracting.contractActivitiesProducts.get('changeLogs').toJS(),
  loadingLogs: contracting.contractActivitiesProducts.get('loadingLogs'),
});

export default connect(mapState, { goBack })(ChangeLogRouter);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/change-log/change-log-router.js